import LanguageDropdown from "components/Language/LanguageDropdown"
import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Message, Menu, Modal, Button, Label} from "semantic-ui-react"
import {withRouter} from "react-router"
import queryString from "qs"
import "pages/Login.css"
import shop from "shop/shop"
import WordPressContainer from "WordPressContainer"
import config from "config"
import { Table } from "semantic-ui-react";
import Responsive from "react-responsive"
import ContactMessage from "components/Messages/ContactMessage"

@withRouter
export default class LocalFooter extends Component {
	constructor() {
		super()
		this.state = {
			user    : "",
			password: "",
			forgetPassword: false
		}
		shop.whoami()
	}

	handleLogin = ( e ) => {
		const {history} = this.props
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		console.log( {query} )
		const {referrer} = query
		shop.login( {...this.state} )
			.catch( ( err ) => {
				console.error( err )
				shop.toast( translate( "Fehler bei der Anmeldung" ), "error" )
				return false
			} )
			.then( session => {
				if ( !session ) return
				shop.loadCategories()
				shop.cart.hydrate()
				shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
				let redirectTo = referrer || shop.locationAfterLogin
				console.log( "AFTER", redirectTo )
				/*if ( redirectTo ) {
					history.push( redirectTo )
				} else {*/
				if(shop.session.handUser){
					history.push( "/return/admin" )
				}
				else{
					history.push( "/return" )
				}
				//}
			} )

		e.preventDefault()
	}

	handleUserChange = ( event ) => {
		this.setState( {
			user: event.target.value
		} )
	}

	handlePasswordChange = ( event ) => {
		this.setState( {
			password: event.target.value
		} )
	}



	handleModalPassword = () => {
		this.setState(prevState => ({
			forgetPassword: !prevState.forgetPassword
		}));
		console.log("forgetPassword", this.state.forgetPassword);
	};

	render() {
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		return (<Fragment><div style={{marginTop: "60px"}}><div className="bg-silver fixed bottom-0 left-0 right-0">
				
<Menu fluid
        secondary
        size="small">
    <Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "data"} )}}
            position="right">{translate( "Data Policy" )}</Menu.Item>
    <Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "imprint"} )}}>{translate( "imprint" )}</Menu.Item>
</Menu>

</div></div>


<Modal
    open={query.modal && query.slug}
    closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
    <Modal.Content>
        <WordPressContainer postType="page"
                            slug={query.slug} />
    </Modal.Content>
</Modal>

<Modal
    open={query.modal === "data"}
    closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
    <Modal.Content>
        <WordPressContainer postType="page"
                            slug="datenschutz" />
    </Modal.Content>
</Modal>

<Modal
    open={query.modal === "imprint"}
    closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
    <Modal.Content>
        <WordPressContainer postType="page"
                            slug="impressum" />
    </Modal.Content>
</Modal>

<Modal
    open={query.modal === "agb"}
    closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
    <Modal.Content>
        <WordPressContainer postType="page"
                            slug="agb" />
    </Modal.Content>
</Modal>
</Fragment>
        )}}


// WEBPACK FOOTER //
// ./src/theme/lindt/components/LocalFooter.js